<template lang="pug">
  .confirmation
    .modal
      svg(xmlns="http://www.w3.org/2000/svg" width="37.31" height="37.329" viewBox="0 0 37.31 37.329")
        g(stroke-width="3")
          ellipse(cx="18.655" cy="18.664" rx="18.655" ry="18.664" stroke="none")
          ellipse(cx="18.655" cy="18.664" rx="17.155" ry="17.164" fill="none")
        path(d="M3624.407,337.244l4.4,4.4,8-8.288" transform="translate(-3610.9 -318.419)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
      h4 {{msg}}
      .notes(v-if="msg == 'Quote Request Submitted!'")
        p You should receive a response in one (1) business day.
        ul
          li Pricing
          li Estimated Lead Time
          li Product Literature

      .actions(v-if="!$root.confirmation.processing")
        p
          a.back(@click="goToState(returnState)") {{ returnMsg }}
        
        p(v-if="$root.confirmation.confirm") 
          a.close(@click="$root.confirmation.open = false") Cancel
      .action(v-else)
        p Processing

      financing(v-if="this.$root.currentSite == 'MityLite' && msg == 'Quote Request Submitted!'")
</template>

<script>
export default {
  name: "Confirmation",
  props: ["msg", "returnState", "returnMsg"],
  data() {
    return {};
  },
  methods: {
    goToState(state) {
      if (state == "delete") {
        this.$root.confirmation.processing = true;
        this.$parent.deleteQuote();
      } else {
        this.$root.currentState = state;
        this.$root.confirmation.open = false;
        this.$root.confirmation.confirm = false;
      }
    }
  },
  created: function() {
    if (
      this.$root.currentSite === "MityLite" &&
      this.$root.env != "development"
    ) {
      window.lintrk("track", { conversion_id: 2702146 });
    } else if (
      this.$root.currentSite === "Holsag" &&
      this.$root.env != "development"
    ) {
      window.lintrk("track", { conversion_id: 17706337 });
    }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/reset.scss";
@import "../assets/styles/variables.scss";

//GLOBALS
#app .confirmation {
  height: calc(100% - 50px);
  width: 100%;
  background: #bcbcbc;
  padding-top: 5em;
  .modal {
    margin: auto;
    background: #fff;
    width: 90%;
    text-align: center;
    padding: 1em;
    border-radius: 10px;
    h4 {
      line-height: 150%;
      margin: 1em;
      font-weight: 500;
    }
    .notes {
      margin: 0 -1em 2em;
      font-size: 0.95em;
      p {
        margin: 1em 2em;
      }
      ul {
        list-style: none; /* Remove default bullets */
        text-align: left;
        width: 50%;
        margin: 1em auto;
        li {
          font-style: italic;
          color: $text_color;
          margin-bottom: 0.5em;
        }
      }

      ul li::before {
        content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
        color: $alert_yellow; /* Change the color */
        font-weight: bold; /* If you want it to be bold */
        display: inline-block; /* Needed to add space between the bullet and the text */
        width: 1em; /* Also needed for space (tweak if needed) */
        margin-left: -1em; /* Also needed for space (tweak if needed) */
      }
    }
    svg {
      fill: $primary_color;
    }
    .actions {
      p {
        margin-bottom: 1em;
      }
    }
  }
}
</style>
